var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9994 0C12.0892 0 0 12.0879 0 26.9994C0 41.9108 12.0892 54 26.9994 54C41.9096 54 54 41.9108 54 26.9994C54 12.0879 41.9121 0 26.9994 0ZM22.047 40.8692L10.1578 28.9826L14.1205 25.0199L22.047 32.944L39.8783 15.1114L43.8409 19.0741L22.047 40.8692Z",
    fill: "#6AC259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTickIcon);
export default __webpack_public_path__ + "static/media/selectTick_Icon.79bb2e40fa175c84bb33cfb94e5faf7f.svg";
export { ForwardRef as ReactComponent };